import React from 'react';

const MeetOurTeam = () => {
    return (
        <div>
            <div className="px-4 py-8 lg:py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-16" bis_skin_checked="1">
                <p className="text-center mb-6 text-2xl font-semibold uppercase tracking-tight text-white md:text-3xl">Top Instructors</p>
                <p className="text-center mb-24 text-base text-white md:text-md">Learn from the best instructors around the globe at Blink</p>
                <div className="flex items-center space-y-24 lg:space-y-0 flex-col lg:flex-row justify-center" bis_skin_checked="1">
                    <div className="p-4 relative" bis_skin_checked="1">
                        <div className="text-center mb-4 absolute -top-16 right-1/2 transform translate-x-1/2" bis_skin_checked="1">
                            <div className="relative" bis_skin_checked="1">
                                <img alt="profile" src="https://i.ibb.co/GsZjY1T/Andrei-Neagoie.jpg" className="mx-auto object-cover rounded-lg h-40 w-40  border-4 border-blue-600 dark:border-gray-800" />
                            </div>
                        </div>
                        <div className="bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg px-8 py-4 pt-24" bis_skin_checked="1">
                            <div className="text-center" bis_skin_checked="1">
                                <p className="text-2xl text-gray-800 dark:text-white">Andrei Neagoie</p>
                                <p className="text-xl text-gray-500 dark:text-gray-200 font-light">Senior Executive</p>
                                <p className="text-md text-gray-500 w-60 dark:text-gray-400 mx-auto py-4 font-light">Andrei is the senior executive of some of the of our  technical section.</p>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 relative" bis_skin_checked="1">
                        <div className="text-center mb-4 absolute -top-16 right-1/2 transform translate-x-1/2" bis_skin_checked="1">
                            <div className="relative" bis_skin_checked="1">
                                <img alt="profile" src="https://i.ibb.co/5GrX8qq/caleb-kingston.jpg" className="mx-auto object-cover rounded-lg h-40 w-40  border-4 border-blue-600 dark:border-gray-800" />
                            </div>
                        </div>
                        <div className="bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg px-8 py-4 pt-24" bis_skin_checked="1">
                            <div className="text-center" bis_skin_checked="1">
                                <p className="text-2xl text-gray-800 dark:text-white">Caleb Kingston</p>
                                <p className="text-xl text-gray-500 dark:text-gray-200 font-light">CEO </p>
                                <p className="text-md text-gray-500 w-60 dark:text-gray-400 mx-auto py-4 font-light">Caleb Kingston is the Cheif Executive Officer.</p>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 relative" bis_skin_checked="1">
                        <div className="text-center mb-4 absolute -top-16 right-1/2 transform translate-x-1/2" bis_skin_checked="1">
                            <div className="relative" bis_skin_checked="1">
                                <img alt="profile" src="https://i.ibb.co/b3sxzqN/Angela-Yu.jpg" className="mx-auto object-cover rounded-lg h-40 w-40  border-4 border-blue-600 dark:border-gray-800" />
                            </div>
                        </div>
                        <div className="bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg px-8 py-4 pt-24" bis_skin_checked="1">
                            <div className="text-center" bis_skin_checked="1">
                                <p className="text-2xl text-gray-800 dark:text-white">Angela Yu</p>
                                <p className="text-xl text-gray-500 dark:text-gray-200 font-light">Head of HR</p>
                                <p className="text-md text-gray-500 w-60 dark:text-gray-400 mx-auto py-4 font-light">Hi! My name is Angela Yu! I'm the Head of HR with two decades of experience.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default MeetOurTeam;